const getRoundedRating = rating => {
  if (!rating) {
    return 0;
  }
  return Math.round(rating * 10) / 10;
};

export default getRoundedRating;
